// Generated by ReScript, PLEASE EDIT WITH CARE


var mumbai = "mumbai";

var delhi_NCR = "delhi ncr";

var delhi = "delhi";

var bangalore = "bangalore";

var hyderabad = "hyderabad";

var chennai = "chennai";

var ahmedabad = "ahmedabad";

var jaipur = "jaipur";

var pune = "pune";

var kolkata = "kolkata";

var surat = "surat";

var lucknow = "lucknow";

var coimbatore = "coimbatore";

var indore = "indore";

var nagpur = "nagpur";

var chandigarh = "chandigarh";

var vadodara = "vadodara";

var ludhiana = "ludhiana";

var kochi = "kochi";

var nashik = "nashik";

export {
  mumbai ,
  delhi_NCR ,
  delhi ,
  bangalore ,
  hyderabad ,
  chennai ,
  ahmedabad ,
  jaipur ,
  pune ,
  kolkata ,
  surat ,
  lucknow ,
  coimbatore ,
  indore ,
  nagpur ,
  chandigarh ,
  vadodara ,
  ludhiana ,
  kochi ,
  nashik ,
  
}
/* No side effect */
